import Home from '../components/HomePage.vue';
import GameSchedules from '../components/GameSchedules.vue';
import GameStandings from '../components/GameStandings.vue';
import TeamRosters from '../components/TeamRosters.vue';
import LeagueRules from '../components/LeagueRules.vue';
import ContactUs from '../components/ContactUs.vue';
import GSThursdayB from '../components/GSThursdayB.vue';
import GSSundayB from '../components/GSSundayB.vue';
import GSSundayC from '../components/GSSundayC.vue';
import StandingsThurB from '../components/StandingsThurB.vue';
import StandingsSunB from '../components/StandingsSunB.vue';
import StandingsSunC from '../components/StandingsSunC.vue';
import TeamRosterThurB from '../components/TeamRosterThurB.vue';
import TeamRosterSunB from '../components/TeamRosterSunB.vue';
import TeamRosterSunC from '../components/TeamRosterSunC.vue';
import HallOfFame from '../components/HallOfFame.vue';
import BasketballCourt from '../components/BasketballCourt.vue';
import DivisionLeadersThurB from '../components/DivisionLeadersThurB.vue';
import DivisionLeadersSunB from '../components/DivisionLeadersSunB.vue';
import DivisionLeadersSunC from '../components/DivisionLeadersSunC.vue';

import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    component: Home,
    meta: {
      title: 'Kontra Sports Adult Basketball League | Orange County & Seal Beach',
      metaTags: [
        {
          name: 'description',
          content: 'Kontra Sports is an adult basketball league in Orange County and Seal Beach, California. View schedules, standings, rosters, rules, and league updates for all divisions.'
        }
      ]
    }
  },
  {
    path: '/home',
    component: Home,
    meta: {
      title: 'Home | Kontra Sports Adult Basketball League',
      metaTags: [
        {
          name: 'description',
          content: 'Welcome to Kontra Sports, an adult basketball league in Orange County and Seal Beach. Find league updates, schedules, standings, rosters, and rules.'
        }
      ]
    }
  },
  {
    path: '/schedules',
    component: GameSchedules,
    meta: {
      title: 'Game Schedules | Kontra Sports Adult Basketball League',
      metaTags: [
        {
          name: 'description',
          content: 'View game schedules for all Kontra Sports adult basketball league divisions.'
        }
      ]
    }
  },
  {
    path: '/standings',
    component: GameStandings,
    meta: {
      title: 'Standings | Kontra Sports Adult Basketball League',
      metaTags: [
        {
          name: 'description',
          content: 'View current division standings for the Kontra Sports adult basketball league in Orange County and Seal Beach.'
        }
      ]
    }
  },
  {
    path: '/rosters',
    component: TeamRosters,
    meta: {
      title: 'Rosters and Stats | Kontra Sports Adult Basketball League',
      metaTags: [
        {
          name: 'description',
          content: 'View team rosters and player stats for Kontra Sports adult basketball league divisions.'
        }
      ]
    }
  },
  {
    path: '/rules',
    component: LeagueRules,
    meta: {
      title: 'League Rules | Kontra Sports Adult Basketball League',
      metaTags: [
        {
          name: 'description',
          content: 'Read the official rules for the Kontra Sports adult basketball league.'
        }
      ]
    }
  },
  {
    path: '/contact',
    component: ContactUs,
    meta: {
      title: 'Contact Us | Kontra Sports Adult Basketball League',
      metaTags: [
        {
          name: 'description',
          content: 'Contact Kontra Sports for questions about league registration, schedules, standings, rosters, rules, and general information.'
        }
      ]
    }
  },
  {
    path: '/thursdayBGameSchedule',
    component: GSThursdayB,
    meta: {
      title: "Thursday 6'3 Division Schedule | Kontra Sports",
      metaTags: [
        {
          name: 'description',
          content: "View the Thursday 6'3 Division game schedule for the Kontra Sports adult basketball league."
        }
      ]
    }
  },
  {
    path: '/sundayBGameSchedule',
    component: GSSundayB,
    meta: {
      title: "Sunday 6'3 Division Schedule | Kontra Sports",
      metaTags: [
        {
          name: 'description',
          content: "View the Sunday 6'3 Division game schedule for the Kontra Sports adult basketball league."
        }
      ]
    }
  },
  {
    path: '/sundayCGameSchedule',
    component: GSSundayC,
    meta: {
      title: "Sunday 6'1 Division Schedule | Kontra Sports",
      metaTags: [
        {
          name: 'description',
          content: "View the Sunday 6'1 Division game schedule for the Kontra Sports adult basketball league."
        }
      ]
    }
  },
  {
    path: '/standingsThurB',
    component: StandingsThurB,
    meta: {
      title: "Thursday 6'3 Division Standings | Kontra Sports",
      metaTags: [
        {
          name: 'description',
          content: "View the Thursday 6'3 Division standings for the Kontra Sports adult basketball league."
        }
      ]
    }
  },
  {
    path: '/standingsSunB',
    component: StandingsSunB,
    meta: {
      title: "Sunday 6'3 Division Standings | Kontra Sports",
      metaTags: [
        {
          name: 'description',
          content: "View the Sunday 6'3 Division standings for the Kontra Sports adult basketball league."
        }
      ]
    }
  },
  {
    path: '/standingsSunC',
    component: StandingsSunC,
    meta: {
      title: "Sunday 6'1 Division Standings | Kontra Sports",
      metaTags: [
        {
          name: 'description',
          content: "View the Sunday 6'1 Division standings for the Kontra Sports adult basketball league."
        }
      ]
    }
  },
  {
    path: '/teamRosterThurB',
    component: TeamRosterThurB,
    meta: {
      title: "Thursday 6'3 Division Rosters | Kontra Sports",
      metaTags: [
        {
          name: 'description',
          content: "View team rosters for the Thursday 6'1 Division in the Kontra Sports adult basketball league."
        }
      ]
    }
  },
  {
    path: '/teamRosterSunB',
    component: TeamRosterSunB,
    meta: {
      title: "Sunday 6'3 Division Rosters | Kontra Sports",
      metaTags: [
        {
          name: 'description',
          content: "View team rosters for the Sunday 6'3 Division in the Kontra Sports adult basketball league."
        }
      ]
    }
  },
  {
    path: '/teamRosterSunC',
    component: TeamRosterSunC,
    meta: {
      title: "Sunday 6'1 Division Rosters | Kontra Sports",
      metaTags: [
        {
          name: 'description',
          content: "View team rosters for the Sunday 6'1 Division in the Kontra Sports adult basketball league."
        }
      ]
    }
  },
  {
    path: '/hallOfFame',
    component: HallOfFame,
    meta: {
      title: 'Hall of Fame | Kontra Sports',
      metaTags: [
        {
          name: 'description',
          content: 'View past Kontra Sports championship teams, including a list of past season winners and team photos in the Hall of Fame.'
        }
      ]
    }
  },
  {
    path: '/basketballCourt',
    component: BasketballCourt,
    meta: {
      title: 'AIMS Big Gym Court Map | Kontra Sports',
      metaTags: [
        {
          name: 'description',
          content: 'View the court map for the AIMS Big Gym to see where each court number is located for Kontra Sports games.'
        }
      ]
    }
  },
  {
    path: '/divisionLeadersThurB',
    component: DivisionLeadersThurB,
    meta: {
      title: "Thursday 6'3 Division Leaders | Kontra Sports",
      metaTags: [
        {
          name: 'description',
          content: "View division leaders for the Thursday 6'3 Division in the Kontra Sports adult basketball league."
        }
      ]
    }
  },
  {
    path: '/divisionLeadersSunB',
    component: DivisionLeadersSunB,
    meta: {
      title: "Sunday 6'3 Division Leaders | Kontra Sports",
      metaTags: [
        {
          name: 'description',
          content: "View division leaders for the Sunday 6'3 Division in the Kontra Sports adult basketball league."
        }
      ]
    }
  },
  {
    path: '/divisionLeadersSunC',
    component: DivisionLeadersSunC,
    meta: {
      title: "Sunday 6'1 Division Leaders | Kontra Sports",
      metaTags: [
        {
          name: 'description',
          content: "View division leaders for the Sunday 6'1 Division in the Kontra Sports adult basketball league."
        }
      ]
    }
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router;